export default "__VITE_ASSET__BEGUvuTh__"